// extracted by mini-css-extract-plugin
module.exports = {"parent":"State_parent__1ypkj","icon":"State_icon__2VoBZ","stateGroup":"State_stateGroup__2ooEG","stateDetail":"State_stateDetail__3I1Iz"};